
import React from "react";
import { Calendar, Users, MessageSquare, Goal, Star, Clock, Brush, LineChart } from "lucide-react";
import { FeatureCard } from "./FeatureCard";

export function FeaturesGrid() {
  const features = [
    {
      icon: Calendar,
      title: "Lesplanning",
      description: "Plan je lessen vooruit en houd overzicht",
    },
    {
      icon: Users,
      title: "Community",
      description: "Deel je lesplannen met andere trainers",
    },
    {
      icon: MessageSquare,
      title: "Feedback",
      description: "Krijg tips en verbeter je lessen",
    },
    {
      icon: Goal,
      title: "Doelen",
      description: "Stel doelen op voor je sporters en volg hun voortgang",
    },
    {
      icon: Star,
      title: "Favorieten",
      description: "Bewaar je favoriete oefeningen en deel ze met anderen",
    },
    {
      icon: Clock,
      title: "Tijdlijn",
      description: "Visualiseer je les met een handige tijdlijn",
    },
    {
      icon: Brush,
      title: "Thema's",
      description: "Pas het uiterlijk aan naar jouw voorkeuren",
    },
    {
      icon: LineChart,
      title: "Analytics",
      description: "Krijg inzicht in je lessen met handige grafieken",
    },
  ];

  return (
    <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
      {features.map((feature, index) => (
        <FeatureCard
          key={index}
          icon={feature.icon}
          title={feature.title}
          description={feature.description}
        />
      ))}
    </div>
  );
}
